export interface IDim1Option {
  human: string;
  key: string;
  schoolType?: string;
  lists: string[];
  path?: string | string[];
  dimension: number;
  isActive: boolean;
  optionType?: string;
  optionFilter?: any;
  schoolLevel?: string;
  order: number;
  isCalculatedGraphQuery?: boolean;
  getGraphQuery?: Function;
  filterStudent?: (student) => boolean;
  children?: any;
}

export const Nine_To_12_Options: IDim1Option[] = [
  {
    human: 'All my students',
    key: 'ALL_HS_STUDENTS',
    schoolType: '9_to_12',
    schoolLevel: 'HS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: null,
    dimension: 1,
    isActive: true,
    order: 0,
    isCalculatedGraphQuery: false,
    getGraphQuery: () => `isHS=true`,
    filterStudent: student => true,
  },
  {
    human: 'Grade',
    key: 'GRADE',
    schoolType: '9_to_12',
    schoolLevel: 'MS',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'studentDetails.grade',
    dimension: 1,
    isActive: false,
    order: 1,
    children: [],
  },
  {
    human: 'Class',
    key: 'CLASS',
    schoolType: '9_to_12',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'studentDetails.classOf',
    dimension: 1,
    isActive: false,
    order: 2,
    children: [],
  },
  {
    human: 'Grad date',
    key: 'GRAD_PLAN',
    schoolType: '9_to_12',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'gradPlanningDetails.plannedGraduationDate',
    dimension: 1,
    isActive: false,
    order: 3,
    children: [],
  },
  {
    human: 'Official class',
    key: 'OFFICIAL_CLASS',
    schoolType: '9_to_12',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: 'studentDetails.officialClass',
    dimension: 1,
    isActive: false,
    order: 4,
    children: [],
  },
  {
    human: 'Special population',
    key: 'SPECIAL_POPULATION',
    schoolType: '9_to_12',
    lists: ['MY_STUDENTS', 'ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY', 'MANAGER'],
    path: ['spedDetails.isSped', 'ellDetails.isEll'],
    dimension: 1,
    isActive: false,
    order: 5,
    children: [],
  },
  {
    human: 'Attendance point person',
    key: 'ATTENDANCE_POINT_PERSON',
    schoolType: '9_to_12',
    lists: ['ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY'],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'ATTENDANCE' },
    dimension: 1,
    isActive: false,
    order: 6,
    children: [],
  },
  {
    human: 'Academic point person',
    key: 'ACADEMIC_POINT_PERSON',
    schoolType: '9_to_12',
    lists: ['ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY'],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'ACADEMIC' },
    dimension: 1,
    isActive: false,
    order: 7,
    children: [],
  },
  {
    human: 'Post-secondary point person',
    key: 'POST_SECONDARY_POINT_PERSON',
    schoolType: '9_to_12',
    lists: ['ATTENDANCE', 'ACADEMIC', 'POST_SECONDARY'],
    path: 'pointPeople',
    optionType: 'user',
    optionFilter: { type: 'POSTSECONDARY' },
    dimension: 1,
    isActive: false,
    order: 8,
    children: [],
  },
];
